import { DownOutlined, EditOutlined, KeyOutlined, LogoutOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Dropdown,
  Form,
  Image,
  Input,
  Modal,
  Row,
  Upload,
  message,
  Button,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Logo from "../../assets/images/logo-for-logins.png";
import notfound from "../../assets/images/face-1.jpg";
import ProfileImage from "../../assets/images/for-profile_icons.svg";
import DeleteModal from "../../components/DeleteModal";
import apiPath from "../../constants/apiPath";
import { AuthContext } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { capitalize } from "../../helper/functions";
import moment from "moment";
import { useAppContext } from "../../context/AppContext";
import SingleImageUpload from "../SingleImageUpload";
import { Container } from "react-bootstrap";

function Header({ name: sectionHeading, onPress, totalDuration = 0 }) {
  const {
    logs,
    logsCount,
    unreadNotiCount,
    notifications,
    setRefreshAppContext,
  } = useAppContext();

  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [totalWorkoutTime, setTotalWorkoutTime] = useState("0:00");
  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [logoModalVisible, setLogoModalVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { request } = useRequest();
  const [refresh, setRefresh] = useState(false);
  const { logout, userProfile, setIsAdmin } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [logoLoading, setLogoLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [screenLogoFile, setScreenLogoFile] = useState(null);
  const [screenLogoPreview, setScreenLogoPreview] = useState(null);
  const [screenLogoLoading, setScreenLogoLoading] = useState(false);
  const [currentScreenLogo, setCurrentScreenLogo] = useState(null);

  // Resolve relative logo URLs to full URLs
  const resolveLogoUrl = (url) => {
    if (!url || url.length === 0) return null;
    if (url.startsWith('http')) return url;
    return `http://16.27.46.246:8000${url}`;
  };

  useEffect(() => {
    if (!userProfile) return;
    setIsAdmin(true);
  }, [userProfile]);

  useEffect(() => { window.scrollTo(0, 0); }); // block body: never return scrollTo's value (a Promise in Chrome) or React calls it as cleanup and crashes

  // Listen for total duration changes from Dashboard
  useEffect(() => {
    const handleTotalDurationChange = (event) => {
      const totalSeconds = event.detail;
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      setTotalWorkoutTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);
    };
    
    const initialDuration = localStorage.getItem('currentDayTotalDuration') || '0';
    const totalSeconds = parseInt(initialDuration);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    setTotalWorkoutTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);
    
    window.addEventListener('totalDurationChanged', handleTotalDurationChange);
    
    return () => {
      window.removeEventListener('totalDurationChanged', handleTotalDurationChange);
    };
  }, []);

  // Update menu items to include logo upload
  const items = [
    {
      label: "Edit Profile",
      key: "1",
      icon: <EditOutlined />,
    },
    {
      label: "Logo Settings",
      key: "4",
      icon: <UploadOutlined />,
    },
    {
      label: "Change Password",
      key: "2",
      icon: <KeyOutlined />,
    },
    {
      label: "Logout",
      key: "3",
      icon: <LogoutOutlined />,
      danger: true,
    }
  ];

  useEffect(() => {
    if (!isOpen) return document.body.classList.remove("edit-dropdown");
    document.body.classList.add("edit-dropdown");

    return () => {
      document.body.classList.remove("edit-dropdown");
    };
  }, [isOpen]);

  const showDeleteConfirm = (record) => {
    setIsLogoutModalVisible(true);
  };

  const handleMenuClick = (e) => {
    if (e.key === "1") {
      setProfileVisible(true);        
    }
    if (e.key === "2") {
      setVisible(true);          
    }
    if (e.key === "3") {
      showDeleteConfirm();
    }
    if (e.key === "4") {
      setLogoModalVisible(true);
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  // Function to handle logo upload
  const handleLogoUpload = async () => {
  if (!logoFile) {
    ShowToast("Please select a logo image", Severty.ERROR);
    return;
  }

  setLogoLoading(true);
  
  const formData = new FormData();
  formData.append('file', logoFile);
  
  console.log("Uploading logo file:", logoFile.name);
  
  request({
    url: apiPath.uploadLogo || '/gym_owner/upload_logo/',
    method: "POST",
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onSuccess: (responseData) => {
      console.log("Logo upload success:", responseData);
      setLogoLoading(false);
      
      if (responseData && responseData.status === 200) {
        ShowToast(responseData.message || "Logo uploaded successfully!", Severty.SUCCESS);
        setLogoModalVisible(false);
        setLogoFile(null);
        setLogoPreview(null);
        
        if (responseData.data && responseData.data.logo_url) {
          console.log("New logo URL:", responseData.data.logo_url);
          
          setProfile(prev => ({
            ...prev,
            logo_image: responseData.data.logo_url
          }));
          
          setSelected(prev => ({
            ...prev,
            logo_image: responseData.data.logo_url
          }));
        }
        
        setRefresh(prev => !prev);
      } else {
        ShowToast(responseData?.message || "Failed to upload logo", Severty.ERROR);
      }
    },
    onError: (error) => {
      console.error("Logo upload error:", error);
      setLogoLoading(false);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.message || 
        "Something went wrong";
      
      ShowToast(errorMessage, Severty.ERROR);
    },
  });
};

  // Before upload validation
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('You can only upload image files!');
      return false;
    }
    
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      message.error('Image must be smaller than 10MB!');
      return false;
    }
    
    const reader = new FileReader();
    reader.onload = (e) => {
      setLogoPreview(e.target.result);
    };
    reader.readAsDataURL(file);
    
    setLogoFile(file);
    return false;
  };

  const handleRemoveLogo = () => {
    setLogoFile(null);
    setLogoPreview(null);
  };

  // Screen logo upload (PNG only, transparent bg)
  const handleScreenLogoUpload = async () => {
    if (!screenLogoFile) {
      ShowToast("Please select a PNG image", Severty.ERROR);
      return;
    }
    setScreenLogoLoading(true);
    const formData = new FormData();
    formData.append('file', screenLogoFile);
    request({
      url: apiPath.uploadScreenLogo || '/gym_owner/upload_screen_logo',
      method: "POST",
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      onSuccess: (responseData) => {
        setScreenLogoLoading(false);
        if (responseData?.status === 200) {
          ShowToast("Screen logo uploaded!", Severty.SUCCESS);
          setScreenLogoFile(null);
          setScreenLogoPreview(null);
          if (responseData.data?.screen_logo) {
            setCurrentScreenLogo(responseData.data.screen_logo);
          }
          setRefresh(prev => !prev);
        } else {
          ShowToast(responseData?.message || "Upload failed", Severty.ERROR);
        }
      },
      onError: (error) => {
        setScreenLogoLoading(false);
        ShowToast(error?.response?.data?.message || "Upload failed", Severty.ERROR);
      },
    });
  };

  const handleDeleteScreenLogo = () => {
    request({
      url: apiPath.deleteScreenLogo || '/gym_owner/delete_screen_logo',
      method: "DELETE",
      onSuccess: (data) => {
        if (data?.status === 200) {
          ShowToast("Screen logo removed", Severty.SUCCESS);
          setCurrentScreenLogo(null);
          setRefresh(prev => !prev);
        }
      },
      onError: () => ShowToast("Failed to remove", Severty.ERROR),
    });
  };

  const beforeScreenLogoUpload = (file) => {
    const isPng = file.type === 'image/png' || file.name.toLowerCase().endsWith('.png');
    if (!isPng) {
      message.error('Only PNG files accepted (transparent background required)');
      return false;
    }
    if (file.size / 1024 / 1024 > 5) {
      message.error('File must be under 5MB');
      return false;
    }
    const reader = new FileReader();
    reader.onload = (e) => setScreenLogoPreview(e.target.result);
    reader.readAsDataURL(file);
    setScreenLogoFile(file);
    return false;
  };

  const handleCreate = (values) => {
    onCreate(values);
  };

  const onCreate = (values) => {
    const { old_password, new_password } = values;
    const payload = {
      old_password,
      new_password,
    };

    setLoading(true);

    request({
      url: apiPath.changePassword,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast("Password changed successfully!", Severty.SUCCESS);
          setVisible(false);
          logout();
          setTimeout(() => {
            navigate("/", { replace: true });
            if (setRefreshAppContext) setRefreshAppContext(prev => !prev);
          }, 1000);
        } else {
          ShowToast(data.message || "Failed to change password", Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(
          error?.response?.data?.message || "Something went wrong",
          Severty.ERROR
        );
      },
    });
  };

  useEffect(() => {
    request({
      url: apiPath.profile,
      method: "GET",
      onSuccess: (data) => {
        if (data.status === 200 && data.data && data.data.user) {
          const userData = data.data.user;
          setProfile({
            id: userData.id,
            name: userData.name,
            email: userData.email,
            role: userData.role,
            franchise_id: userData.franchise_id,
            status: userData.status,
            is_superuser: userData.is_superuser,
            phone_number: userData.phone_number,
            country: userData.country,
            state: userData.state,
            city: userData.city,
            created_at: userData.created_at,
            profile_image: userData.profile_image,
            logo_image: userData.logo_image,
            is_approved: userData.is_approved,
            is_email_verified: userData.is_email_verified,
            is_phone_verified: userData.is_phone_verified,
            image: userData.profile_image,
            profilePic: userData.profile_image || ProfileImage,
          });
          setSelected({
            id: userData.id,
            name: userData.name,
            email: userData.email,
            role: userData.role,
            franchise_id: userData.franchise_id,
            status: userData.status,
            is_superuser: userData.is_superuser,
            phone_number: userData.phone_number,
            country: userData.country,
            state: userData.state,
            city: userData.city,
            created_at: userData.created_at,
            profile_image: userData.profile_image,
            logo_image: userData.logo_image,
            is_approved: userData.is_approved,
            is_email_verified: userData.is_email_verified,
            is_phone_verified: userData.is_phone_verified,
            image: userData.profile_image,
            profilePic: userData.profile_image || ProfileImage,
          });
        }
      },
      onError: (error) => {
        console.error("Error fetching profile:", error);
        ShowToast("Failed to load profile data", Severty.ERROR);
      },
    });
  }, [refresh]);

  // Load current screen logo
  useEffect(() => {
    request({
      url: apiPath.getScreenLogo || '/gym_owner/get_screen_logo',
      method: "GET",
      onSuccess: (data) => {
        if (data?.status === 200 && data?.data?.screen_logo) {
          setCurrentScreenLogo(data.data.screen_logo);
        }
      },
      onError: () => {},
    });
  }, [refresh]);

  return (
    <>
      <Container>
        <Row gutter={[24, 0]} className="justify-content-between mx-0">
          <Col span={24} className="header-control">
            <div className="header-main-outer">
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "rgba(0,0,0,0.7)",
                padding: "8px 16px",
                borderRadius: "8px",
                border: "2px solid rgb(111, 112, 113)"
              }}>
                <span style={{ color: "#fff", fontWeight: "bold" }} className="for-timer-main">
                  TOTAL WORKOUT TIME: 
                  <span style={{ color: "#a8a8a8", fontSize: "18px", marginLeft: "8px", fontFamily: 'monospace' }}>
                    {totalWorkoutTime}
                  </span>
                </span>
              </div>

              <div className="tabLogo">
                <img 
                  src={resolveLogoUrl(profile?.logo_image) || Logo} 
                  height={160} 
                  alt="" 
                  style={{ objectFit: "contain" }}
                  onError={(e) => {
                    e.target.src = Logo;
                  }}
                />
              </div>

              <div className="profileDropdownMain">
                <Dropdown
                  open={isOpen}
                  onOpenChange={(open) => setIsOpen(open)}
                  className="edit-box"
                  menu={menuProps}
                  trigger={["click"]}
                >
                  <span className="ant-dropdown-trigger ant-dropdown-open">
                    <div className=" d-flex align-items-center gap-2">
                      <div className="userImg">
                        <Image
                          src={
                            profile?.profile_image ||
                            profile?.image ||
                            ProfileImage
                          }
                          preview={false}
                          alt="Profile"
                          fallback={notfound}
                        />
                      </div>
                      <div className="d-none d-xl-block">
                        <div className="userName">
                          {profile?.franchise_id || "Gym Tv"}
                          <span
                            role="img"
                            aria-label="down"
                            className="anticon anticon-down ms-2"
                          >
                            <DownOutlined />{" "}
                          </span>
                        </div>
                        {/* {profile?.role && (
                          <div className="userRole">
                            {profile.role}
                          </div>
                        )} */}
                      </div>
                    </div>
                  </span>
                </Dropdown>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Logo Upload Modal — Dashboard Logo + Screen Logo */}
      <Modal
        title="Logo Management"
        open={logoModalVisible}
        onCancel={() => {
          setLogoModalVisible(false);
          setLogoFile(null);
          setLogoPreview(null);
          setScreenLogoFile(null);
          setScreenLogoPreview(null);
        }}
        footer={null}
        width={680}
        className="tab_modal"
      >
        <div style={{ padding: "10px 0" }}>
          <Row gutter={[24, 24]}>
            {/* Dashboard Logo */}
            <Col span={12}>
              <div style={{ 
                border: "1px solid #333", 
                borderRadius: "12px", 
                padding: "20px",
                background: "#1a1a2e",
                height: "100%"
              }}>
                <h3 style={{ color: "#fff", marginBottom: "16px", fontSize: "16px", textAlign: "center" }}>Dashboard Logo</h3>
                <p style={{ color: "#888", fontSize: "12px", textAlign: "center", marginBottom: "16px" }}>Displayed in the header bar</p>
                <div style={{ 
                  width: "100%", 
                  height: "80px", 
                  margin: "0 auto 16px",
                  border: "1px dashed #444",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  background: "#111"
                }}>
                  {logoPreview ? (
                    <img src={logoPreview} alt="Logo preview" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                  ) : profile?.logo_image ? (
                    <img src={resolveLogoUrl(profile.logo_image)} alt="Current logo" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                  ) : (
                    <div style={{ color: "#666" }}>
                      <UploadOutlined style={{ fontSize: "20px", display: "block", marginBottom: "4px" }} />
                      <span style={{ fontSize: "12px" }}>No logo</span>
                    </div>
                  )}
                </div>
                <div style={{ textAlign: "center" }}>
                  <Upload name="logo" accept="image/*" beforeUpload={beforeUpload} showUploadList={false} multiple={false}>
                    <Button icon={<UploadOutlined />} size="small">Select Image</Button>
                  </Upload>
                  {logoFile && (
                    <div style={{ marginTop: "12px" }}>
                      <p style={{ margin: "2px 0", color: "#aaa", fontSize: "12px" }}>{logoFile.name} ({(logoFile.size / 1024 / 1024).toFixed(1)}MB)</p>
                      <Button type="primary" size="small" loading={logoLoading} onClick={handleLogoUpload} style={{ marginTop: "8px", marginRight: "8px" }}>Upload</Button>
                      <Button type="link" danger size="small" onClick={handleRemoveLogo}>Remove</Button>
                    </div>
                  )}
                </div>
                <div style={{ marginTop: "12px", padding: "8px", background: "#0d0d1a", borderRadius: "6px" }}>
                  <p style={{ color: "#666", fontSize: "11px", margin: 0 }}>Formats: JPG, PNG, WebP &bull; Max 10MB</p>
                </div>
              </div>
            </Col>

            {/* Screen Logo */}
            <Col span={12}>
              <div style={{ 
                border: "1px solid #333", 
                borderRadius: "12px", 
                padding: "20px",
                background: "#1a1a2e",
                height: "100%"
              }}>
                <h3 style={{ color: "#fff", marginBottom: "16px", fontSize: "16px", textAlign: "center" }}>Screen Logo</h3>
                <p style={{ color: "#888", fontSize: "12px", textAlign: "center", marginBottom: "16px" }}>Displayed on the TV screen (bottom-left)</p>
                <div style={{ 
                  width: "100%", 
                  height: "80px", 
                  margin: "0 auto 16px",
                  border: "1px dashed #444",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  background: "#111"
                }}>
                  {screenLogoPreview ? (
                    <img src={screenLogoPreview} alt="Screen logo preview" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                  ) : currentScreenLogo ? (
                    <img src={resolveLogoUrl(currentScreenLogo)} alt="Current screen logo" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
                  ) : (
                    <div style={{ color: "#666" }}>
                      <UploadOutlined style={{ fontSize: "20px", display: "block", marginBottom: "4px" }} />
                      <span style={{ fontSize: "12px" }}>No logo</span>
                    </div>
                  )}
                </div>
                <div style={{ textAlign: "center" }}>
                  <Upload name="screen_logo" accept=".png" beforeUpload={beforeScreenLogoUpload} showUploadList={false} multiple={false}>
                    <Button icon={<UploadOutlined />} size="small">Select PNG</Button>
                  </Upload>
                  {screenLogoFile && (
                    <div style={{ marginTop: "12px" }}>
                      <p style={{ margin: "2px 0", color: "#aaa", fontSize: "12px" }}>{screenLogoFile.name} ({(screenLogoFile.size / 1024 / 1024).toFixed(1)}MB)</p>
                      <Button type="primary" size="small" loading={screenLogoLoading} onClick={handleScreenLogoUpload} style={{ marginTop: "8px", marginRight: "8px" }}>Upload</Button>
                      <Button type="link" danger size="small" onClick={() => { setScreenLogoFile(null); setScreenLogoPreview(null); }}>Remove</Button>
                    </div>
                  )}
                  {!screenLogoFile && currentScreenLogo && (
                    <Button type="link" danger size="small" onClick={handleDeleteScreenLogo} style={{ marginTop: "8px" }}>Delete Current</Button>
                  )}
                </div>
                <div style={{ marginTop: "12px", padding: "8px", background: "#0d0d1a", borderRadius: "6px" }}>
                  <p style={{ color: "#666", fontSize: "11px", margin: 0 }}>PNG only (transparent bg) &bull; Max 5MB</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout?`}
          show={isLogoutModalVisible}
          
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            navigate("/");
          }}
        />
      )}

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {visible && (
        <ChangePassword
          show={visible}
          handleCreate={handleCreate}
          hide={() => {
            setVisible(false);
          }}
          loading={loading}
        />
      )}
    </>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState([]);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
  ];

  const handleImage = (data) => {
    if (data?.length > 0) {
      setImage(data[0].url);
    } else {
      setImage([]);
    }
  };

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      name: data.name,
      email: data.email,
    });

    if (data.profile_image || data.image) {
      setImage(data.profile_image || data.image);
    } else {
      setImage(notfound);
    }
  }, [data]);

  const onEditProfile = (values) => {
    const { email, name } = values;

    if (!image)
      return ShowToast("Please select the profile Image ", Severty.ERROR);

    const payload = {};
    setLoading(true);
    payload.email = email;
    payload.name = name;
    payload.image = image;
    payload.profile_image = image;

    request({
      url: apiPath.updateProfile,
      method: "PUT",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      okText={"Ok"}
      cancelText={"Cancel"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Profile</h4>
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please enter the name!" },
                {
                  pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
                  message:
                    "Only alphabetic characters and single spaces are allowed. No leading/trailing spaces.",
                },
              ]}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                { type: "email", message: "The input is not valid E-mail!" },
                { required: true, message: "Please enter the email!" },
              ]}
            >
              <Input placeholder="Enter Email Address" disabled />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Upload Profile"
              name="image"
              rules={[
                {
                  required: !image,
                  message: "Please enter the profile image!",
                },
              ]}
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"profile"}
                btnName={"upload"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export const AppSetting = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data]);

  const onAppSetting = (values) => {
    setLoading(true);
    request({
      url: apiPath.updateAppSetting,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      width={1200}
      open={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okText={"Ok"}
      cancelText={"Cancel"}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Update App Setting</h4>
      <Form id="create" form={form} onFinish={onAppSetting} layout="vertical">
        <Row gutter={{ xs: [0, 16], md: [16, 0] }}>
          <Col span={24} md={12}>
            <Card title="Android Details">
              <Col span={24}>
                <Form.Item
                  label="App Store URL"
                  name="app_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the app store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter App Store URL" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Version"
                  name="android_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter Android Version" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Share Content"
                  name="android_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share Android Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>

          <Col span={24} md={12}>
            <Card title="IOS Details">
              <Col span={24} className="">
                <Form.Item
                  label="Play Store URL"
                  name="play_store_url"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the play store URL!",
                    },
                  ]}
                >
                  <Input placeholder="Enter Play Store URL" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Version"
                  name="ios_version"
                  rules={[
                    { required: true, message: "Please enter the version!" },
                  ]}
                >
                  <Input placeholder="Enter IOS Version" />
                </Form.Item>
              </Col>

              <Col span={24} className="">
                <Form.Item
                  label="Share Content"
                  name="ios_share_content"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the share content!",
                    },
                  ]}
                >
                  <Input.TextArea
                    showCount
                    maxLength={500}
                    style={{ height: 120, marginBottom: 15 }}
                    placeholder="Share IOS Content"
                  />
                </Form.Item>
              </Col>
            </Card>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, handleCreate, loading }) => {
  const [form] = Form.useForm();
  return (
    <Modal
      open={show}
      okText={"Ok"}
      cancelText={"Cancel"}
      onCancel={hide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">Change Password</h4>
      <Form id="create" form={form} onFinish={handleCreate} layout="vertical">
        <Form.Item
          label="Old Password"
          name="old_password"
          hasFeedback
          rules={[
            { required: true, message: "Please enter the old password!" },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
              ),
              message:
                "New password at least contain 8 characters, at least contain one capital letter, at least contain one small letter, at  least contain one digit, atleast contain one special character",
            },
          ]}
        >
          <Input.Password placeholder="Enter Old Password" />
        </Form.Item>
        <Form.Item
          label="New Password"
          name="new_password"
          dependencies={["old_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please enter the new password!" },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
              ),
              message:
                "New password at least contain 8 characters, at least contain one capital letter, at least contain one small letter, at  least contain one digit, atleast contain one special character",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("old_password") === value) {
                  return Promise.reject(
                    new Error("Old password & new password must be different!")
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter New Password" />
        </Form.Item>
        <Form.Item
          label="Confirm New Password"
          name="confirm_new_password"
          dependencies={["new_password"]}
          hasFeedback
          rules={[
            { required: true, message: "Please enter the confirm password!" },
            {
              pattern: new RegExp(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
              ),
              message:
                "Confirm password atleast contain 8 characters, atleast contain one captital letter, atleast contain one small letter, atleast contain one digit, atleast contain one special character",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("new_password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("New & Confirm password do not match!")
                );
              },
            }),
          ]}
        >
          <Input.Password placeholder="Enter Confirm Password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Header;